<template>
  <v-btn
    @click="openModal('PAY_INVOICES_MODAL')"
    elevation="0"
    color="primary"
    class="mr-3"
    small
  >
    <v-icon left small> mdi-text-box-check-outline </v-icon>
    <span class="caption">
      {{ $t('hausefulInvoices.actions.payInvoices') }}
    </span>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdminPayInvoicesButton',

  methods: {
    ...mapActions(['openModal']),
  }
}
</script>
